export default __webpack_public_path__ + "static/media/HomePageTitleNew.a8f3a9f0.png";